import type { ClientEnvironmentDTO } from '../infrastructure/models';

/**
 * Build a lookup map from environment ID → environment name.
 * Returns the map so callers can do `O(1)` lookups per row.
 */
export const buildEnvironmentNameMap = (
  environments: ClientEnvironmentDTO[],
): Map<string, string> => {
  const map = new Map<string, string>();
  environments.forEach((env) => {
    map.set(env.id, env.name);
  });
  return map;
};

/**
 * Resolve an environment ID to a human-readable name.
 * Falls back to the raw ID when no matching environment is found.
 */
export const getEnvironmentName = (
  environmentId: string | null | undefined,
  environmentMap: Map<string, string>,
): string => {
  if (!environmentId) return '—';
  return environmentMap.get(environmentId) ?? environmentId;
};
